import { SuperAdminPluginsPage } from "../../operator/console/super-admin-plugins";

export default function ConsoleSuperAdminPlugins() {
  return <SuperAdminPluginsPage />;
}
